import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteFaxOrganizeModalProps = {
  show: boolean
  itemType: 'folder' | 'label'
  itemName: string
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteFaxOrganizeModal: React.FC<
  MessageCenterDeleteFaxOrganizeModalProps
> = ({ show, itemType, itemName, onCancel, onDelete }) => {
  const name = itemName.trim() || `this ${itemType}`
  const isFolder = itemType === 'folder'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title={isFolder ? 'Delete folder' : 'Delete label'}
      description={
        isFolder
          ? `Are you sure you want to delete ${name}? Fax messages in this folder will return to the inbox.`
          : `Are you sure you want to delete ${name}? This label will be removed from the fax messages that use it.`
      }
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default MessageCenterDeleteFaxOrganizeModal
